import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PerfOverallComponent} from './perf-overall.component';
import {AlertBannerModule} from "../../lib/alert-banner";


@NgModule({
  declarations: [PerfOverallComponent],
  imports: [
    CommonModule,
    AlertBannerModule.forRoot(),
  ],
  exports: [PerfOverallComponent]
})
export class PerfOverallModule {
}
